import React, { useState, useCallback, useEffect } from 'react'
import ScrollButton from './ScrollButton'
import { grid, buttonContainer } from './miniCarousel.module.css'
import { isNonEmptyString } from '@/utils/checks'
const Carousel = ({
  id = '',
  itemsCount = 0,
  maxItemsCount = 4,
  title = '',
  subTitle = '',
  children,
  className = '',
  itemWidth = 410,
  hideNavigation = false,
  smallArrows = false,
  topArrowPosition = '',
  titleClassName = ''
}) => {
  const miniCarouselId = `mini-carousel-${id}`
  const containerId = `${miniCarouselId}-scroll`
  const [showLeftArrow, setShowLeftArrow] = useState(false)
  const [showRightArrow, setShowRightArrow] = useState(
    itemsCount > maxItemsCount
  )

  useEffect(() => {
    setShowRightArrow(itemsCount > maxItemsCount)
  }, [itemsCount, maxItemsCount])

  const scrollDiv = (e) => {
    const container = document.getElementById(containerId)
    if (e === -1) {
      container.scroll(container.scrollLeft - itemWidth, 0)
    } else {
      container.scroll(container.scrollLeft + itemWidth, 0)
    }
  }

  const handleOnScroll = useCallback(({ currentTarget }) => {
    const hasUserScrollToTheLeft = currentTarget.scrollLeft > 0
    setShowLeftArrow(hasUserScrollToTheLeft)

    const leftMostScrollValue = Math.ceil(
      currentTarget.clientWidth + currentTarget.scrollLeft
    )
    const userReachedRightSide =
      leftMostScrollValue >= currentTarget.scrollWidth

    setShowRightArrow(!userReachedRightSide)
  })

  const position = topArrowPosition ? '' : 'items-center'

  const navigationDisplayStyles = hideNavigation
    ? 'opacity-0 md:group-hover:opacity-100 w-[58px]'
    : 'w-[50px]'

  const navigationStyles = `hidden md:flex justify-center ${position} ${navigationDisplayStyles}`

  return (
    <div className={`${miniCarouselId} ${className}`}>
      {isNonEmptyString(title) && (
        <h2
          className={`pb-4 font-FieldsVariable text-lg font-medium leading-6 text-gray-1100 ${titleClassName}`}
        >
          {title}
        </h2>
      )}

      <div className={`relative mx-auto my-0 ${hideNavigation ? 'group' : ''}`}>
        {showLeftArrow && (
          <div
            className={`${buttonContainer} ${navigationStyles} left-0 bg-gradient-to-r from-white via-white to-transparent`}
          >
            <ScrollButton
              onClick={() => scrollDiv(-1)}
              smallArrow={smallArrows}
              className={topArrowPosition ? `mt-${topArrowPosition}` : ''}
              left
            />
          </div>
        )}
        <div className="hide-scroll -mx-4 flex flex-col items-start gap-2 overflow-scroll px-4 md:mx-0 md:block md:px-0">
          <div
            className={`relative mx-auto my-0 ${hideNavigation ? 'group' : ''}`}
          >
            {showLeftArrow && (
              <div
                className={`${buttonContainer} ${navigationStyles} left-0 bg-gradient-to-r from-white via-white to-transparent`}
              >
                <ScrollButton
                  onClick={() => scrollDiv(-1)}
                  smallArrow={smallArrows}
                  className={topArrowPosition ? `mt-${topArrowPosition}` : ''}
                  left
                />
              </div>
            )}
            <div
              className={`${grid}`}
              onScroll={handleOnScroll}
              id={containerId}
            >
              {children}
            </div>
            {showRightArrow && (
              <div
                className={`${buttonContainer} ${navigationStyles} right-0 bg-gradient-to-r from-transparent via-white to-white`}
              >
                <ScrollButton
                  onClick={() => scrollDiv(1)}
                  smallArrow={smallArrows}
                  className={topArrowPosition ? `mt-${topArrowPosition}` : ''}
                  right
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default Carousel
